import { Paper } from '@mui/material';
import { Row } from 'spw-shared/globalComponents';
import styled from 'styled-components';

export const TitleRow = styled(Row)`
  && {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    padding-bottom: 8px;
  }
`;

export const TextRow = styled(Row)`
  && {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    padding-bottom: 21px;
  }
`;

export const CustomSpaceTypeModalCard = styled(Paper)`
  width: 400px;

  .title {
    font-size: 18px;
    line-height: 24px;
    font-weight: 500;

    padding: 24px 24px 8px;
  }

  .content {
    padding: 24px 24px 8px;
  }

  .error-message {
    margin: 4px 0 8px;
    font-size: 14px;
    line-height: 20px;
  }

  .checkbox-label {
    margin: 8px 0 24px;

    .MuiCheckbox-root {
      margin-right: 7px;
    }
  }

  .space-type-name-input {
    margin-bottom: 32px;
  }

  .info {
    display: flex;
    align-items: flex-start;
    margin-top: 24px;

    .info-text {
      margin-left: 8px;
      font-size: 14px;
      line-height: 20px;
      strong {
        font-weight: 500;
      }
    }
  }

  .delete-button {
    margin-left: auto !important;
  }
`;
